import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getOverallQuestion } from 'global/js/helpers';
import * as Actions from 'containers/Home/actions';
import * as OverallActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import TextArea from 'components/TextArea/TextArea';
import './OverallAdditionalFeedback.scss';

class OverallAdditionalFeedback extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Checks for any custom questions, and returns the link to the first
     * question or to the overall additional page. We only need to worry 
     * about the previous page, since the next page is always 'than you'.
     * We first count the number of custom overall questions. If there are
     * none, the previous page is the 'TC' page, otherwise its the custom
     * page with number of custom questions as part of the URL params.
     */
    checkCustomQuestions = () => {
        let numCustomQuestions = 0;

        for (const question of this.props.surveyData.OverallSubmission.OverallQuestions)
            if (question.Type.toLowerCase().includes('custom question'))
                numCustomQuestions++;

        return numCustomQuestions === 0 ? '/TC' : `/CustomQuestion/${numCustomQuestions}/${numCustomQuestions}`;
    }

	/**
	 * Called when there is a change to the text area value. Handles updating
	 * the text value state.
	 *
	 * @param    comment : {String}
	 */
    handleChange = (comment) => {
        this.props.overallActions.setOverallAnswer({
            type: 'LastFeedback',
            comment: comment
        });
    }

    render() {
        const surveyData = this.props.surveyData;
        const question = getOverallQuestion(surveyData.OverallSubmission.OverallQuestions, 'LastFeedback');
        const questionComment = question.Answer.AnswerComment;
        const questionText = question.Text;
        const questionType = question.Type;
        const overallAdditionalClasses = classNames('wrapper overall-additional', {
            'inactive': this.props.isDataPosting
        });

        return (
            <section className={overallAdditionalClasses}>
                {surveyData.IsBackup && (
                    <Header customerData={surveyData.Evaluator} isOverall={true} />
                )}

                <div className='container'>
                    <h1 className="stay-name">Overall <br /> Experience</h1>
                    
                    <div className='content'>
                        <Question questionText={questionText} />

                        <TextArea 
                            handleChange={this.handleChange} 
                            textValue={questionComment} 
                        />

                        <Navigation
                            actions={this.props.actions}
                            answerValue={true}
                            didDirtyPostFail={this.props.didDirtyPostFail}
                            didPostFail={this.props.didPostFail}
                            history={this.props.history}
                            individualID={this.props.individualID}
                            isDataPosted={this.props.isDataPosted}
                            isDataPosting={this.props.isDataPosting}
                            isNoInternet={this.props.isNoInternet}
                            isOverall={true}
                            isSubmit={true}
                            nextLink='/ThankYou'
                            prevLink={this.checkCustomQuestions()}
                            prodTourID={this.props.prodTourID}
                            surveyData={this.props.surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        didDirtyPostFail: state.surveyReducer.didDirtyPostFail,
        didPostFail: state.surveyReducer.didPostFail,
        individualID: state.dataReducer.individualID,
        isDataPosted: state.surveyReducer.isDataPosted,
        isDataPosting: state.surveyReducer.isDataPosting,
        isNoInternet: state.surveyReducer.isNoInternet,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        overallActions: bindActionCreators(OverallActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OverallAdditionalFeedback));



// WEBPACK FOOTER //
// ./application/containers/OverallAdditionalFeedback/OverallAdditionalFeedback.jsx